// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDKHGN1vHwN6FnRJFJTuB7GrLuK9rpHtoM",
  authDomain: "sharifscada-331011.firebaseapp.com",
  projectId: "sharifscada-331011",
  storageBucket: "sharifscada-331011.appspot.com",
  messagingSenderId: "698923707644",
  appId: "1:698923707644:android:41e3f32ed5a1ede9fa3b79",
  databaseURL: "https://sharifscada-331011.firebaseio.com"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// ✅ Request permission and get token
export const requestPermission = async (registration) => {
  return getToken(messaging, { apiKey: firebaseConfig.apiKey })
    .then((currentToken) => {
      if (currentToken) {
        // console.log('Client Token: ', currentToken);
        return currentToken;
      } else {

        console.log('Failed to generate the app registration token.');
        return null;
      }
    })
    .catch((err) => {
      console.log('An error occurred when requesting to receive the token.', err);
      return null;
    });
};

// ✅ Handle foreground messages
// export const onMessageListener = () =>
//   new Promise((resolve) => {
//     onMessage(messaging, (payload) => {
//       resolve(payload);
//     });
//   });

export const setupOnMessageListener = (callback) => {
  onMessage(messaging, (payload) => {
    callback(payload);
  });
};
